import "./Contact.css";
import { useState } from "react";
import Swal from "sweetalert2";

function Contact() {
  const [name, setName] = useState();
  // const [lasts,setLast]=useState()
  const [phone, setPhone] = useState();
  const [message, setMessage] = useState();
  const [info, setInfo] = useState();

  const showAlert = () => {
    Swal.fire({
      title: "Success",
      text: "Your message has been successfully sent",
      icon: "success",
      confirmButtonText: "Ok",
    });
    setName(" ");
    setPhone(" ");
    setMessage(" ");
    setInfo(" ");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlert();
  };
  return (
    <div className="contact">
      <div className="page">
        <div className="hero">
          <div className="con">
            <div className="content">
              <div className="form">
                <div className="title">
                  <h1>Contact Comfort Limo</h1>
                  <p>It is our pleasure and honor to help you</p>
                </div>
                <div>
                  <div className="two">
                    <div className="head">
                      <h2>Send Comfort Limo Team Message!</h2>
                    </div>
                    <div>
                      <form onSubmit={handleSubmit}>
                        <div className="input">
                          <label htmlFor="name">Full Name</label>
                          <input
                            id="name"
                            type="text"
                            name="name"
                            required
                            value={name}
                            className="form-control"
                            onChange={(e) => {
                              setName(e.target.value);
                            }}
                          />
                        </div>
                        {/* <div className="input">
                                                <label htmlFor="mail">Email Address</label>
                                                <input id='mail' type="text" name='mail' required className='form-control' onChange={(e)=>{setLast(e.target.value)}} />
                                            </div> */}
                        <div className="input">
                          <label htmlFor="phone">Mobile Number</label>
                          <input
                            id="phone"
                            type="text"
                            name="phone"
                            required
                            value={phone}
                            className="form-control"
                            onChange={(e) => {
                              setPhone(e.target.value);
                            }}
                          />
                        </div>
                        <div className="input">
                          <label htmlFor="message">Question / Message</label>
                          <textarea
                            className="form-control"
                            name="message"
                            id="message"
                            value={message}
                            onChange={(e) => {
                              setMessage(e.target.value);
                            }}></textarea>
                        </div>
                        <div className="input">
                          <label htmlFor="info">Emdress</label>
                          <input
                            id="info"
                            type="text"
                            name="info"
                            required
                            value={info}
                            className="form-control"
                            onChange={(e) => {
                              setInfo(e.target.value);
                            }}
                          />
                        </div>
                        <div className="button">
                          <button type="submit" className="btn">
                            Send Message
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
